import { render, staticRenderFns } from "./LowerLimitTable.vue?vue&type=template&id=3b55a943&scoped=true"
import script from "./LowerLimitTable.vue?vue&type=script&lang=js"
export * from "./LowerLimitTable.vue?vue&type=script&lang=js"
import style0 from "./LowerLimitTable.vue?vue&type=style&index=0&id=3b55a943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55a943",
  null
  
)

export default component.exports